import { useState, useEffect } from 'react';
import AdminLogin from './AdminLogin';
import GalleryManager from './GalleryManager';
import ArticleManager from './ArticleManager';
import EventManager from './EventManager';
import './AdminDashboard.css';

const AdminDashboard = ({ onNavigate }) => {
  const [user, setUser] = useState(null);
  const [activeTab, setActiveTab] = useState('gallery');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    try {
      const token = localStorage.getItem('adminToken');
      if (!token) {
        setLoading(false);
        return;
      }

      const response = await fetch('http://localhost:3001/api/auth/check', {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      const data = await response.json();
      if (data.authenticated) {
        setUser(data.user);
      } else {
        localStorage.removeItem('adminToken');
      }
    } catch (err) {
      console.error('Auth check failed:', err);
      localStorage.removeItem('adminToken');
    } finally {
      setLoading(false);
    }
  };

  const handleLogin = (userData) => {
    setUser(userData);
  };

  const handleLogout = async () => {
    try {
      const token = localStorage.getItem('adminToken');
      await fetch('http://localhost:3001/api/auth/logout', {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      localStorage.removeItem('adminToken');
      setUser(null);
    } catch (err) {
      console.error('Logout failed:', err);
      // Still clear local state even if request fails
      localStorage.removeItem('adminToken');
      setUser(null);
    }
  };

  if (loading) {
    return <div className="admin-loading">Loading...</div>;
  }

  if (!user) {
    return <AdminLogin onLogin={handleLogin} />;
  }

  return (
    <div className="admin-dashboard">
      {/* Header */}
      <header className="admin-header">
        <div className="admin-header-left">
          <h1>SNDP Admin Dashboard</h1>
        </div>
        <div className="admin-header-right">
          <span className="admin-user">Welcome, {user.username}</span>
          <button onClick={handleLogout} className="btn-logout">Logout</button>
          <button onClick={() => onNavigate('home')} className="btn-home">
            Back to Website
          </button>
        </div>
      </header>

      {/* Sidebar Navigation */}
      <div className="admin-layout">
        <aside className="admin-sidebar">
          <nav>
            <button
              className={activeTab === 'gallery' ? 'active' : ''}
              onClick={() => setActiveTab('gallery')}
            >
              📸 Gallery Manager
            </button>
            <button
              className={activeTab === 'articles' ? 'active' : ''}
              onClick={() => setActiveTab('articles')}
            >
              📰 News & Articles
            </button>
            <button
              className={activeTab === 'events' ? 'active' : ''}
              onClick={() => setActiveTab('events')}
            >
              📅 Event Manager
            </button>
          </nav>
        </aside>

        {/* Main Content */}
        <main className="admin-content">
          {activeTab === 'gallery' && <GalleryManager />}
          {activeTab === 'articles' && <ArticleManager />}
          {activeTab === 'events' && <EventManager />}
        </main>
      </div>
    </div>
  );
};

export default AdminDashboard;
